import React from "react";

const Footer = () => {
  return (
    <footer className="">
      <div className="footer  ">
      <div className="col-lg-5">
        Powered By{" "}
        <a
          target="_blank"
          href="https://srinivasansoftwaresolutions.com/"
          className="footer-link"
        >
          SSS
        </a>
      </div>
      <div className="col-lg-7 footer-right">
        <a href="http://vmrda.gov.in/" className="footer-link">
          Privacy Policy
        </a>
        <a href="/termsandconditions" className="footer-link">
          Terms of Service
        </a>
        <a href="http://vmrda.gov.in/contactus.aspx" className="footer-link">
          Contact Us
        </a>
      </div>
      </div>
      
    </footer>
  );
};

export default Footer;
